import { useCallback, useRef, useEffect, useTransition } from "react";
import CleanArabicString from "../../../auxiliary/CleanArabicString";
import search from './search.module.css'
import { useData } from "../../dentistContext/DentistConferenceContext";
import ButtonsMenu from "../../../auxiliary/ButtonsMenu/ButtonsMenu";
import PhoneBookLogo from "../../../../styles/svg/wpu/phoneBook.svg"
import TransportLogo from "../../../../styles/svg/wpu/transport.svg"



const SearchBox = () => {
  const [isPending, startTrasition] = useTransition()
  const {state, setFilteredData} = useData()
  const data = state.data;
  const filterString = useRef(false);
  const goToPhones=()=>{}
  const goToTransport=()=>{}
  const btns = 
  [
    ["دليل الهاتف", 55, PhoneBookLogo, goToPhones],
    ["طلب دعم فني", 55, TransportLogo, goToTransport],
    ["تكلم مع الدعم الفني", 55, PhoneBookLogo, goToPhones],
  ]
  const handleOnSearchChange = useCallback(() => {
    if (
      typeof filterString.current.value === "string" &&
      filterString.current.value.length > 0
    ) {
      const ss = CleanArabicString(filterString.current.value);
      const ss1 = ss.split(" ");
      if (data && data.length > 0) {
        startTrasition(() => {
          setFilteredData(() => {
            return data.filter((element) => {
              const search_Item =" " + element.number +" " + CleanArabicString(element.fullname) + " ";
              let matches = 0;
              ss1.forEach((word) => {
                const i = search_Item.search(word.trim());
                i > 0 ? ++matches : (matches = 0);
              });
              return matches > (ss1.length - 1) ? true : false;
            });
          });
        });
      }
    } else
      startTrasition(() => {
        setFilteredData(() => data);
      });
  }, [data]);

  const newSearch = () => {
    if (
      typeof filterString.current.value === "string" &&
      filterString.current.value.length > 0
    ) {
      filterString.current.value = "";
      handleOnSearchChange();
    }
    filterString.current.focus();
  }
  
  useEffect(() => {
    handleOnSearchChange();
  }, [handleOnSearchChange]);

  return (
    <div className={search.box}>
      <label htmlFor="boxinput" className={search.label}>بحث سريع</label>
      <div className={search.headermenu}>
        <ButtonsMenu btns={btns}/>
      </div>
      <button htmlFor="boxinput" className={search.btn} onClick={newSearch}>
        بحث جديد
      </button>
      <input
        name="boxinput"
        className={search.input}
        type="search"
        id="filterString"
        onChange={handleOnSearchChange}
        lang="ar"
        ref={filterString}
      />
    </div>
  );
};
export default SearchBox;
